import { put, call } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';

// Actions
import {
  reportsMainGenerateReportProgress
} from 'Redux/actions';

import {
  getTimeZone,
  handleAsyncReport,
  getCategoryFilter,
  generateReportInstance,
  baseReportConditions,
  isJsonFormat
} from 'Modules/reports/views/main/components/reportsTab/helper';

function* getStopSummaryGroupReport(report, page, rowsPerPage, sortField, sortOrder) {
  const { filterType, filterArray, startRange, endRange, otherFilters, unitsSelected, filterEntity } = report.filters;
  let minutes = otherFilters.minute ? otherFilters.minute * 60 : 0;
  const { timeZone, sendByEmail, emailsTo, name, timeframeName, categoryName, delayed, dataResultPath } = report;
  const baseConditionsQuery = baseReportConditions({ report, name, dataResultPath, timeZone, delayed, unitsSelected, timeframeName , filterType, filterArray, categoryName, startRange, endRange})

  const addColumnLabel = (report?.exportType === 'csv') ?
                        [{
                          "column": "driverName",
                          "header": "Driver"
                        },{
                          "column": "stop",
                          "header": "Stop Title"
                        }]: [];
  let payload = {
    conditions: {
      ...baseConditionsQuery,
      sortField: {
        field: sortField || "driverId",
        order: sortOrder === 'desc' ? 'DESC' : 'ASC'
      }
    },
    offset: page,
    limit: rowsPerPage
  }
  if (report.export) {
     payload = {
      conditions: {
        ...payload.conditions,
        exportOptions: {
          sendByEmail,
          emailsTo,
          culture: report.lang,
          timeZone: getTimeZone(timeZone),
          format: {
            fileFormat: report?.exportType  || "json",
            formatOptions: "{}",
            durationFormat: report?.durationFormat
          },
          folderName: "px-customer-reports",
          filePrefixName: "stopSummaryReport",
          columns: [
            ...addColumnLabel,
            {
              "column": "dateTime",
              "header": "Time & Date"
            },
            {
              "column": "address",
              "header": "Address"
            },
            {
              "column": "status",
              "header": "Status"
            },
            {
              "column": "duration",
              "header": "Duration"
            }
          ]
        }
      },
      limit: isJsonFormat(report?.exportType, dataResultPath) ? rowsPerPage : 5000,
      offset: isJsonFormat(report?.exportType, dataResultPath) ? page : 1
    }
  }
  try {
    let data = yield call(
      clientQuery,
      `query ($conditions: ReportConditionsInput, $limit: Int, $offset: Int) {
        Report: getStopSummaryReport (conditions: $conditions, limit: $limit, offset: $offset) {
          ${generateReportInstance(report.export, dataResultPath, report.exportFromTable) ?  

            `reportInstanceId`
          :`
            total
            limit
            offset
            category
            items {
              driverId
              driverName
              dates
              noData
            }
          `}
        }
      }`,
      payload,
      endpoints.GRAPHQL_PX_REPORTING,
    );

    yield handleAsyncReport(report, data)
  } catch (exc) {
    report.loading = false
    yield put(reportsMainGenerateReportProgress(report))
  }
}


export default getStopSummaryGroupReport;
